module.exports = __webpack_public_path__ + "static/media/features.2a28faaf.svg";